export const LEAD_TAG_FETCH_REQUEST = 'LEAD_TAG_FETCH_REQUEST';
export const LEAD_TAG_FETCH = 'LEAD_TAG_FETCH';
export const LEAD_TAG_CLEAR = 'LEAD_TAG_CLEAR';
